// extracted by mini-css-extract-plugin
module.exports = {"editButton":"EditAssetButton_editButton__cLXJ0","hovered":"EditAssetButton_hovered__VwBzN"};